<template>
  <div>

    <router-view />
  </div>
</template>

<script>
export default {
  name: 'UserLayout'
}
</script>

<style scoped>

</style>
